import type { ReactNode } from 'react';

import { classNames } from '@/utils/classNames';

import styles from '@/styles/common.module.css';

type BadgeTone = 'primary' | 'neutral' | 'warning' | 'danger' | 'success';

type BadgeProps = {
  children: ReactNode;
  className?: string;
  tone?: BadgeTone;
};

const toneClassName: Record<BadgeTone, string> = {
  primary: styles.badgePrimary!,
  neutral: styles.badgeNeutral!,
  warning: styles.badgeWarning!,
  danger: styles.badgeDanger!,
  success: styles.badgeSuccess!,
};

export function Badge({ children, className, tone = 'primary' }: BadgeProps): JSX.Element {
  return <span className={classNames(styles.badge, toneClassName[tone], className)}>{children}</span>;
}
